import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <p>© Copyright 2026 Harvard Computational Robotics Group | 150 Western Ave, Allston, MA 02134</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;




